import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { Shimmer } from "react-shimmer";
import DocumentDownloadButton from "../../DocumentDownloadButton";
import CachedSignedDocument from "./CachedSignedDocument";

interface Props {
  src: string;
}

const size = 200;

function ChatMessageDocument(props: Props) {
  const fallback = <ChatMessageDocument.Fallback height={size} width={size} />;

  return (
    <ChatMessageDocument.Root>
      {props.src.startsWith("s3://") ? (
        fallback
      ) : (
        <Container layoutId={`card-container--index-${props.src.split("?")[0]}`} size={size}>
          <DocumentWrapper>
            <CachedSignedDocument src={props.src} width={size} height={size} fallback={fallback} />
          </DocumentWrapper>
        </Container>
      )}
      <DocumentDownloadButton src={props.src} />
    </ChatMessageDocument.Root>
  );
}

ChatMessageDocument.Root = styled.div`
  width: 200px;
  height: 200px;
`;

ChatMessageDocument.Fallback = styled(Shimmer)`
  border-radius: 12px;
`;

const DocumentWrapper = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;

  embed {
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }
`;

const Container = styled(motion.div)<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

export default ChatMessageDocument;
